export default "__VITE_PUBLIC_ASSET__2b20e338__"